export const API_URL = "https://valerotexasopen.com/share-your-story/api";

export function createMarkup(html) {
	return { __html: html };
}

export function isFieldError(array, val) {
	return array.includes(val);
}

export function scroll() {
	return window.jQuery("html, body").animate(
		{
			scrollTop:
				window.jQuery("h1").offset().top -
				window.jQuery("#header").height() +
				200,
		},
		200,
	);
}
